import { useEffect, useState, useContext, useRef } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2'
ChartJS.register(...registerables);

interface ChartProps {
    data: Array<number>,
    label: Array<string>
}

export const InsightChart: React.FC<ChartProps> = ({data, label}) => {
    const screenRef = useRef(false)
    const [chartDataset, setChartDataset] = useState<any>([])

    useEffect(() => {
        handlDataFormatting()
        screenRef.current = window.matchMedia('(max-width: 470px)').matches
    }, [data])

    function handlDataFormatting () {

        const info = {
                label: '',
                data: data,
                barThickness: screenRef.current ? 12 : 25,
                borderWidth: 1,
                borderRadius: screenRef.current ? 3 : 5,
                backgroundColor: [
                    '#FFD795',
                    '#83C7FF',
                    '#7BDDD8',
                    '#FFC0C0',
                    '#B8FFBF'
                ],
                borderColor: [
                    '#FFD795',
                    '#83C7FF',
                    '#7BDDD8',
                    '#FFC0C0',
                    '#B8FFBF',
                ]
          }

        setChartDataset([info])
    }

    return (
        <Bar 
            data={{
                labels: label,
                datasets: chartDataset
            }}
            height="100%"
            width="100%"
            options={{
                maintainAspectRatio: false, 
                plugins: {
                    legend: {
                        align: 'start',
                        display: false,
                        labels: {
                            boxWidth: 6,
                            usePointStyle: true,
                            boxHeight: 6,
                            color: '#667085',
                            font: {
                                size: 14
                            }
                        }
                    }
                },
                scales: {
                    y: { 
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3
                        },
                        ticks: {
                            color: "#667085",
                            display: true
                        },
                        beginAtZero: true,
                    },
                    x: {  
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3,
                        },
                        ticks: {
                            display: false,
                            color: "#667085",
                            font: {
                                size: screenRef.current ? 8 : 12
                            } 
                        },
                        beginAtZero: true,
                    }
                }
            }}
        />
    )
}
